var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"btn",class:_vm.className,attrs:{"value":_vm.text,"type":"button"}})}
var staticRenderFns = []

export { render, staticRenderFns }